export const resetForm = {
    methods: {
        reset(params) {
            this.form.reset()
            this.form.clear()
            params
        }
    }
}

export default resetForm